export const extractErrorCode = (error: any): string | null =>
  error?.response?.data?.data?.error_code ?? null;
